import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminProcApi, supplierApi } from "../../api";
import { ProcError, ProcForm, ProcLoading, ProcSection } from "../../components/ProcurementLayout";
import { useAsyncData, useMutation } from "../../hooks";

export default function DelistingCreatePage() {
  const navigate = useNavigate();

  const { data: suppliers, loading: suppliersLoading } = useAsyncData(
    () => supplierApi.options(),
    [],
  );

  const [supplierId, setSupplierId] = useState<number | "">("");
  const [reason, setReason] = useState("");
  const [supportingEvidence, setSupportingEvidence] = useState("");

  const { mutate, loading, error } = useMutation(async () => {
    if (!supplierId) throw new Error("Supplier is required.");
    if (!reason.trim()) throw new Error("Reason is required.");
    await adminProcApi.createDelisting({
      supplierId: supplierId as number,
      reason,
      supportingEvidence: supportingEvidence || null,
    });
    navigate("/procurement/admin/delistings");
  });

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-3">
        <Link to="/procurement/admin/delistings" className="text-sm text-emerald-700 hover:underline">&larr; Back to Delistings</Link>
      </div>

      <ProcForm formNo="PROC-FRM-16" title="Supplier Delisting">
        {suppliersLoading && <ProcLoading label="Loading suppliers..." />}
        {error && <ProcError message={error} />}

        <ProcSection title="Delisting Details">
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="sm:col-span-2">
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Supplier *</label>
              <select value={supplierId} onChange={(e) => setSupplierId(e.target.value ? Number(e.target.value) : "")} className="w-full rounded-xl border px-3 py-2 text-sm" required>
                <option value="">Select supplier...</option>
                {(suppliers ?? []).map((s) => <option key={s.id} value={s.id}>{s.name}{s.email ? ` — ${s.email}` : ""}</option>)}
              </select>
            </div>
            <div className="sm:col-span-2">
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Reason *</label>
              <textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={4} className="w-full rounded-xl border px-3 py-2 text-sm" required />
            </div>
            <div className="sm:col-span-2">
              <label className="block text-xs font-semibold uppercase tracking-wide text-slate-500 mb-1">Supporting Evidence (optional)</label>
              <textarea value={supportingEvidence} onChange={(e) => setSupportingEvidence(e.target.value)} rows={3} className="w-full rounded-xl border px-3 py-2 text-sm" />
            </div>
          </div>
        </ProcSection>

        <div className="flex justify-end gap-3 pt-2">
          <Link to="/procurement/admin/delistings" className="rounded-xl border px-5 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50">Cancel</Link>
          <button type="button" onClick={() => mutate()} disabled={loading} className="rounded-xl bg-emerald-700 px-5 py-2.5 text-sm font-semibold text-white hover:bg-emerald-800 disabled:opacity-60">
            {loading ? "Saving…" : "Submit Delisting"}
          </button>
        </div>
      </ProcForm>
    </div>
  );
}
